export default {
    comm: {  //共用     
        back: '返回',
        messagetitle: '单据信息',
        detailtitle: '详细信息',
        login: '登录',
        default: '首页',
        transaction:'交易',
        OrderManagement:'订单管理',
        ReturnManagement:'退货管理',
        apFundQuery:'应付查询',
        OtherApplycations:'其他申请',
        operationmenu: '操作菜单',
        download: '下载中心',
        sortfile: '分类文件',
        help: '帮助中心',
        helpdetail: '文章详情',
        inform:'通知中心',
        report: '报表',
        bulletin:'公告',
        bulletindetail:'公告详情',
        company: '厦门正航软件科技有限公司',
        number: '序',
        startdate: '开始日期',
        enddate: '结束日期',
        alltype: '所有类别',
        tip: '提示',
        tipContent:'提示内容',
        message:'消息',
        unselectwarning:'请至少选择一项',
        viewmore:'查看更多',
        confirm:'确定',
        updatePassword:'修改密码成功',
        btnyes:'是',
        btnno:'否',
        selectexport:'请选择一个导出格式',
        selectprint:'请选择一个打印格式',
        uploadFile:'上传附件',
        viewFile:'查看附件',
        chooseFile:'选择文件',
        uploadConfirmText:'确认上传',
        uploadTiptxt:'将单个文件（不超过20M）拖到此处，或',
        uploadClick:'点击上传',
        uploadSuccess:'上传成功！',
        deleteSuccess:'删除成功！',
        cancelDelete:'已取消删除',
        deleteFileTip:'将删除该附件，是否继续？',
        allFileType:'所有文件',
        fileTypeListTxt:'支持上传格式：',
        fileTypeList:'doc、docx、xlsx、xls、ppt、pptx、txt、jpg、png、gif、bmp、zip、rar、7z、pdf、xmind',
        fileSizeTip:'文件过大,请上传小于等于20M的文件!',
        fileSpecialCharTip:'文件有特殊字符,文件名中不可存在特殊字符,请重新上传!',
        fileMaxNumberTip:'文件上传数量已达上限!',
        fileNullTip:'请选择要上传的文件!',
        allowFileNumberTip:',最多可同时上传3个附件!',
        cancelText:'取消',
        copyClick:'点击复制详情',
        copyFinished:'已复制到剪切板！',
        copyError:'当前浏览器暂不支持自动复制，请手动选择复制！',
        KeyIndicator:'本月关键指标',
        salSalesOrder:'我的订单',
        today:'今天',
        lastWeek:'最近一周',
        lastMonth:'最近一个月',
        lastSeason:'最近一个季',
        lastYear:'最近一年',
        pagesize:'笔/页',
        salDispatchList:'我的发货单',
        salesReturnList:'退货单',
        WebMaterial:'下单',
        orderImport: '订单导入',
        orderImportSer: '订单导入查询',
        itemCodeQuery:'ItemCode询价',
        productPicture:'Item及图片查询',
        preview:'预览',
        pubPriceQuery:'公开报价查询',
        APSearch: '应付查询',
        saveSuc:'保存成功',
        orderArrival:'我的到货单',
        browseFile:'浏览',
        stockRemainQuery:'裕萌库存查询',
    },
    Login: { //登录页
        title: '裕萌客户支授平台',
        database: '账套',
        userId: '帐户',
        password: '密码',
        rempsaaword: '记住密码',
        login: '登录',
        environment: '环境配置',
        InstallPlugin: '安装插件',
        HardwareInfo: '硬件信息',
        DownloadCenter: '下载中心',
        databaseText: '账套不允许为空！',
        userIdText: '帐户不允许为空！',
        passwordText: '密码不允许为空！',
        prompt: '提示',
        failure: '登录失败！',
        userExist: '当前帐号已经在其他地方登录，如果您强制登录对方将登出，是否强制登录？',
        alreadyLogined: '当前浏览器已经有一个登录用户（帐套:{0}, 帐号:{1}).如果您强制登录，此用户将被登出，请确认是否登录？',
        screentip:'建议使用分辨率:宽1360以上,以获得最佳体验',
        loginload:'登录中',
        cookieload:'等待服务器启动中...',
        chromeoutdate:'当前浏览器为谷歌内核，且谷歌内核版本较低，为更好的使用经销商平台，请及时将本浏览器升级至最新版本。',
        firefoxoutdate:'当前浏览器为火狐内核，且火狐内核版本较低，为更好的使用经销商平台，请及时将本浏览器升级至最新版本。',
        outdateconfirm:'我已悉知',
        outdatecancel:'三十天内不再提示',
        webVersion:'版本',
        loginErrorTip:'当前会话不存在用户讯息, 请登录!',
        serverErrorTip:'服务连线异常，请联系管理员重启web服务！'
    },
    APSearch: { //应付查询
        messagedate: '日期',
        billTypeAuto: '期初应收',
        typeNameYF: '应付',
        typeNameYS: '应收',
        typeNameYuF: '预付',
        typeNameYuS: '预收',
        inputpls: '请输入',
        compName:'客户',
        documenttype: '单据种类',
        messagenumber: '单据编号',
        date: '单据日期',
        preRecOAmount:'预收款',
        preRecOAmountCheckText:'显示预收款',
        amountreceivable: '应收金额',
        currentamount: '本期核销金额 ',
        discountamount: '本期折扣金额',
        lateamount: '未核销金额',
        summary: '汇总',
        ShowUnZeroItem:'期初为零不显示',
        ShowUnZeroEnd:'期末为零不显示',
        FromBillNo:'来源订单号'
    },
    orderImport:{
        importDate:'导入日期：',
        orderBillNoLab:'销售订单号：',
        orderBillNo:'销售订单号',
        importDateTime:'导入时间',
        customerNoLab:'客户款号：',
        customerNo:'客户款号',
        importSate:'状态：',
        importSate0:'全部',
        importSate1:'仅成功导入',
        importSate2:'仅失败导入',
        importSateError:'导入失败',
        rowNo:'序号',
        failReason:'失败描述',
        isCustUsed:'指定供应商',
        materialSpec:'中文描述',
        lengthLable:'长度',
        lengthUnit:'长度单位',
        colorLable:'颜色',
        colorName:'颜色中文',
        numLable:'数量',
        addrLale:'地址编号',
        sucTabLable:'导入成功的记录',
        errorTabLable:'导入失败的记录',
        searchTip:'请选择具体条件，以免影响查询效率',
        fileTypeLab:'文件格式：',
        downloadLab:'点击下载模板',
        downloadName:'裕萌集团下单模版'
    },
    UrgentQuery:{
        title:'加急查询',
        X_FillDate:'填写日期：',
        BillNo:'订单号码：',
        customerNoLab:'客户款号：',
        urgentDealStateName:'加急处理状态：',
        BillDate:'下单日期：',
        urgentDealState0:'全部',
        urgentDealState1:'未处理',
        urgentDealState2:'厂商回复中',
        urgentDealState3:'已处理',
        urgentDealState4:'已中止',
        fillDate:'填写日期',
        X_ReplyDate:'YKK完工日期',
        X_YKKCompleteDate:'YKK预测完工日',
        X_YKKDeliverDate:'YKK预测发货日',
        X_PredictDelDate:'加急预计出货日期',
    },
    ShipmentQuery:{
        title:'紧急出货查询',
        BillDate:'申请日期：',
        urgentShipStateName:'紧急出货申请状态：',
        meterialSpe:'品名：',
        X_CarryingType:'出货方式',
        X_IsPartShipment:'部分出货',
        X_OperaExplain:'业务说明',
        X_ShipResult:'出货结果',
        X_ExpCompleteDate:'预计完工日期',
        X_UrgentShipDate:'申请日期',
        X_UrgentShipReplyDate:'回复日期',
        urgentShipState:'状态',
        
    },
    itemCodeQuery:{//ItemCode询价
        supplierId:'供应商代码：',
        length:'长度',
        lenUnit:'长度单位',
        numberId:'数量',
        rowNo:'序号',
        supplier:'供应商',
        unit:'单位',
        account:'折扣',
        sUnitId:'交易单价',
        countFomu:'计算公式',
        matchWarn:'未匹配到供应商信息',
        inputCode:'请输入ItemCode',
        lenUnitWarn:'长度不为空时，长度单位必填',
        watchFomu:'查看公式',
        lenUnitSelC:'C，厘米',
        lenUnitSelI:'I，英寸',
        invoText:'开专票',
    },
    productPicture:{//Item及图片查询
        warnText:'该界面可以查询不同组织ITEM，但是如果查询具体ITEMCODE价格，需要进入相应组织查询',
        materialSpec:'中文名称',
        supplier:'供应商',
        pic1:'图片1',
        pic2:'图片2',
        pic3:'图片3',
    },
    pubPriceQuery:{//公开报价查询
        type: '分类：',
        typeSel2:'拉头',
        typeSel3:'表面处理',
        basZipId:'基础拉链编号：',
        pullHeadId:'拉头编号：',
        faceId:'表面处理编号：',
        specId:'特殊处理编号：',
        supplierId:'供应商编号：',
        supplier:'供应商',
        basZipCode:'基础拉链代码',
        basZipName:'基础拉链',
        pullHeadCode:'拉头代码',
        faceCode:'表面处理代码',
        specCode:'特殊处理代码',
        specName:'特殊处理',
        rLengths:'基准长度',
        lUnitId:'长度单位',
        noTaxPrice:'未税标准报价',
        lnchPrice:'进寸价格（公分）',
        basZipWarn:'基础拉链必填！',
        pullWarn:'基础拉链、拉头必填！',
        faceWarn:'基础拉链、表面处理必填！',
        specWarn:'基础拉链、特殊处理必填！'
    },
    orderArrival:{//我的到货单查询
        orderArrivalSearch:'到货单查询',
        reciveDate:'到货日期',
        orderBillNo:'销售订单号：',
        customerNoLab:'客户款号：',
        inputpls:'请输入',
        fromOrderBillNo:'订单号',
        custNumber:'款号（原）',
        receivingSQty:'到货数量',
        materialSpec:'品名（中文描述）',
        address:'到货地',
        operation:'操作',
    },
    OrderArrivalDetail:{
        orderDetail:'到货单详情',
        BillNo:'单号：',
        BillDate:'下单时间：',
        BizPartnerName:'订货客户：',
        OAmount:'参考总金额：',
        RowNo:'序号',
        orderBillNo:'订单号',
        length:'长度',
        lengthUnit:'长度单位',
        color:'颜色',
        batchNo:'批号',
        SQuantity:'到货数量',
        ArrivalData:'到货日期',
        ArrivalAddress:'到货地',
    },
    salSalesOrder:{//订单查询
        orderSearch:'订单查询',
        orderDate:'单据日期：',
        orderBillNo:'单据编号：',
        FOrgName:'公司：',
        inputpls:'请输入',
        BillDate:'下单时间',
        BillNo:'单号',
        BizPartnerName:'订单客户',
        OAmount:'金额',
        CurrentState:'状态',
        PermitState:'审核状态',
        efficient:'生效',
        unefficient:'未生效',
        closed:'结案',
        audited:'已审核',
        auditting:'审核中',
        unaudit:'未审核',
        operation:'操作',
        CurrId:'币别',
        customerNoLab:'款号：',
        X_NewDate:'新交期：',
        totleNum:'总数量：',
        newDate:'新交期',
        preDate:'原交期',
        customerNo:'款号',
        totalSQty:'总数量',
        strPrice:'含税总金额',
        urgentResult:'加急结果',
        urgentDealStateName:'加急处理状态',
        lateOrderReason:'迟单原因',
        noDelDateReason:'无交期原因',
        urgentShipStateName:'紧急出货申请状态',
        lateOrderExpDate:'迟单预计出货日期',
        urgentApplay:'加急申请',
        urgentShipApplay:'紧急出货申请',
        unSelectTip:'未勾选行项，请选择！',
        Select110Tip:'一次性最多只能选择10笔进行{0}',
        applyError1:'序号{0}订单号码{1}的出库状态为完成，不能进行{2}！',
        applyError2:'序号{0}订单号码{1}的{2}为厂商回复中，不能进行{3}！',
        applyError3:'100条以下交期5天内不可出货！(序号：{0},订单号码:{1})',
        applyError4:'100条以上交期9天内不可出货！(序号：{0},订单号码:{1})',
        urgentLevel:'紧急程度',
        urgentLevel0:'普通',
        urgentLevel1:'加急',
        urgentLevel2:'特急',
        urgentReson:'加急原因',
        hopeDate:'希望日期',
        orderNo:'订单号码',
        customerNo2:'客户款号',
        meterialSpe:'品名规格',
        sQty:'数量',
        supplier:'厂商',
        newDate2:'最新交期',
        commitBtn:'提交',
        urgentError1:'当紧急程度为“特急”时，加急原因不可为空。',
        urgentError2:'序号{0}订单号码{1}的希望日期已过',
        urgentError3:'最新交期早于本次申请的希望日期，请确认。',
        shipmentApply:'紧急出货申请',
        urgentLeave:'出货紧急程度',
        isPartShipment:'是否部分出货',
        operaExplain:'业务说明',
        urgentTypeName:'加急紧急程度',
        personId:'业务人员',
        BizPartnerId:'客户代码',
        shortName:'客户简称',
        orgId:'组织',
        X_Or:'OR号码',
        sUnitId:'交易单位',
        batchNo:'批号',
        YKKStatus_En:'YKK状态-英',
        YKKStatus:'YKK状态',
        supplier:'供应商',
        urgentWarnText:'加急申请注意事项:1、要求7天内出货的订单请务必在下单当天或第二天提出加急请求;2、下单后请及时查看交期，如不满足请立即提出加急请求，以便我司与YKK尽早协调提前材料，安排上线生产，请杜绝即将交货才安排提出; 3、如三天之内我司没有回复加急结果，请默认视为无法提前;4、加急订单是YKK特殊调整生产线，在实际生产中不能完全保证100%按提前后的货期出货，可能会有迟单，遇到这种情况，不接受索赔;',
    },
    salSalesOrderDetail:{
        orderDetail:'订单详情',
        BillNo:'单号：',
        BillDate:'下单日期：',
        BizPartnerName:'订货客户：',
        OAmount:'参考总金额：',
        Remark:'订单备注：',
        remark:'备注',
        CurrentState:'状态：',
        PermitState:'审核状态：',
        RowNo:'序号',
        rowCode:'标识号',
        messagenumber: '订单号：',
        messagedate: '下单日期',
        compName: '客户',
        amount: '金额',
        checkstate: '确认状态',
        goodsstate: '发货状态',
        purchaser: '采购员',
        OAmountWithTax:'小计',
        receiveOrgName: '需求组织',
        number: '序',
        MaterialId: '产品代码',
        MaterialName: '产品名称',
        MaterialSpec: '品名（中文描述）',
        SQuantity: '交易数量',
        Quantity:'基本数量',
        SPrice: '交易价',
        Address: '收货地址',
        RowState:'行项状态',
    },
    salDispatchList:{//发货单
        orderSearch:'发货单查询',
        orderDate:'发货日期：',
        orderBillNo:'销售订单号：',
        FOrgName:'公司：',
        inputpls:'请输入',
        BillDate:'发货日期',
        TotalSQty:'发货数量（总）',
        BillNo:'单号',
        BizPartnerName:'订单客户',
        OAmount:'金额',
        CurrentState:'状态',
        PermitState:'审核状态',
        efficient:'生效',
        unefficient:'未生效',
        closed:'结案',
        audited:'已审核',
        auditting:'审核中',
        unaudit:'未审核',
        operation:'操作',
        CurrId:'币别',
        Address:'发货地址',
        ShortNameString:'物流方式',
        X_LogBillNoString:'物流单号',
        X_NumberString:'件数'
    },
    salDispatchListDetail:{
        orderDetail:'发货单详情',
        BillNo:'单号：',
        BillDate:'下单时间：',
        orderBillNo:'订单号',
        BizPartnerName:'订货客户：',
        OAmount:'参考总金额：',
        Remark:'订单备注：',
        remark:'备注',
        CurrentState:'状态：',
        PermitState:'审核状态：',
        RowNo:'序号',
        rowCode:'标识号',
        messagenumber: '单号',
        messagedate: '日期',
        compName: '客户',
        amount: '金额',
        checkstate: '确认状态',
        goodsstate: '发货状态',
        purchaser: '采购员',
        OAmountWithTax:'含税金额',
        receiveOrgName: '需求组织',
        number: '序',
        MaterialId: '产品代码',
        MaterialName: '产品名称',
        MaterialSpec: '品名（中文描述）',
        SQuantity: '数量',
        Quantity:'基本数量',
        SPrice: '交易价',
        OAmountWithTax: '含税金额',
        Address: '收货地址',
        RowState:'行项状态',
        TotalSQty:'订单总数',
        InventoryState:'发货状态',
        batchNo:"批号",
    },
    salesReturnList:{//退货单
        orderSearch:'退货单查询',
        orderDate:'单据日期：',
        orderBillNo:'单据编号：',
        FOrgName:'公司：',
        inputpls:'请输入',
        BillDate:'下单时间',
        BillNo:'单号',
        BizPartnerName:'订单客户',
        OAmount:'金额',
        CurrentState:'状态',
        PermitState:'审核状态',
        efficient:'生效',
        unefficient:'未生效',
        closed:'结案',
        audited:'已审核',
        auditting:'审核中',
        unaudit:'未审核',
        operation:'操作',
        CurrId:'币别'
    },
    salesReturnListDetail:{
        orderDetail:'订单详情',
        BillNo:'单号：',
        BillDate:'下单日期：',
        BizPartnerName:'订单客户：',
        OAmount:'参考总金额：',
        Remark:'备注：',
        remark:'备注',
        CurrentState:'状态：',
        PermitState:'审核状态：',
        RowNo:'序号',
        rowCode:'标识号',
        messagenumber: '单号',
        messagedate: '日期',
        compName: '客户',
        amount: '金额',
        checkstate: '确认状态',
        goodsstate: '发货状态',
        purchaser: '采购员',
        OAmountWithTax:'含税金额',
        receiveOrgName: '需求组织',
        number: '序',
        MaterialId: '产品代码',
        MaterialName: '产品名称',
        MaterialSpec: '产品规格',
        SQuantity: '交易数量',
        Quantity:'基本数量',
        SPrice: '交易价',
        OAmountWithTax: '含税金额',
        Address: '收货地址',
        RowState:'行项状态',
    },
    button: { //按钮
        Cancel:'取消',
        cancel: '取 消',
        determine: '确 定',
        reset: '重 置',
        search: '搜 索',
        check: '查看',
        addnew:'新增',
        query:'查询',
        print: '打印',
        downloadAccess:'下载附件',
        downloadBillAccess:'下载订单所有附件'
    },
    Default: { //首页
        NumOfShipped:'已发货订单笔数',
        NumOfNewOrdThisMon:'新下单产品数量',
        NumOfReturnOrdThisMon:'退货数量',
        TheTips:'提醒事项',
        PendingOrder:'未生效订单笔数',
        NumOfUnShip:'未出库订单笔数',
        NumOfUnfinReturn:'退货未完成笔数',
        information:'消息区',
        bulletin:'公告区',
        newestdownload:'下载中心',
        nonewestdownload:'暂无最新下载',
        nobulletin:'暂无公告',
        noinformation:'暂无消息',
    },
    Download: { //下载中心
        inputpls: '请输入',
        name: '名称',
        type: '分类',
        operation: '操作',
        intro: '简介',
        date: '日期',
        download: '下载',
        recupdate: '附件最近上传时间',
        accessoryname: '附件名称',
        orderinprogress: '进行中的订单',
        viewall: '查看所有',
        viewalldrawings: '查看所有图纸',
        viewchange: '只查看变更',
        viewchangedrawings: '只查看变更图纸',
        batchdownall: '批次下载所有图纸',
        batchdownchange: '批次下载变更图纸',
        clickdownload: '点击下载',
        downloadall: '批量下载',
        To: '至',
        unselecttip:'您选择的订单暂未有变更图纸！',
        noacc:'无附件',
        number:'序号',
        batchdownacc:'下载所有附件',
        nopower:'无下载权限'
    },
    HelpCenter: { //帮助中心
        inputpls: '请输入',
        name: '名称',
        billNo:'单据编号',
        type: '分类',
        operation: '操作',
        date: '上传时间',
        updatetime: '更新时间',
        publishtime: '发布时间'
    },
    BulletinCenter:{//公告中心
        inputpls: '可搜索主题名称或公告内容',
        sysbulletin:'系统公告',
        salbulletin:'系统更新',
        epbulletin:'企业通讯',
        publisher:'发布人',
        maintitle:'主题',
        keyword:'关键字',
        uplaodtime:'上传时间',
        sendtime:'发送时间',
        downloadAccess:'下载附件'
    },
    Order: { //订单
        messagedate: '单据日期',
    },
    Home: {
        changepassword: '修改密码',
        billsetting: '单据设定',
        register: '登录信息',
        delivercar: '购物车',
        back: '退出',
        oldpassword: '旧密码：',
        newpassword: '新密码：',
        confirmpassword: '确认密码：',
        oldpswpls: '请输入旧密码',
        newpswpls: '请输入新密码',
        againpsw: '请再次输入密码',
        errpsw: '两次输入密码不一致!',
        symbolerr: '密码中不可包含特殊字符“<”或“>”',
        logininfo:'登录信息',
        createtime:'创建时间',
        lastlogindate:'登录时间',
        ipaddress:'本次登录IP',
        membertype:'用户类型',
        commonuser:'普通用户',
        tempuser:'临时账户',
        client:'客户',
        supplier:'供应商',
        unknow:'未知',
        toolbarShowStyle:'工具栏显示方式',
        showIcon:'只显示图标',
        showIconAndText:'显示图标和文本',
        showText:'只显示文本',
        fieldRawTextType:'栏位显示风格',
        showcodeandname:'显示代码和名称',
        showname:'显示名称',
        showcode:'显示代码',
        billsettingsucess:'单据设定成功',
        oldpwderror:'密码框内内容不得为空',
        PhoneNumber:'联系方式',
        userInfo:'用户信息',
        customer:'客户',
        email:'联系邮箱',
        Address:'送货地址',
        Country:'国家/地区',
        Province:'省份',
        City:'城市',
        ContactAddress:'联系地址',
        Postalcode:'邮政编码'
    },
    StockRemainQuery:{//裕萌库存查询
        materialSpec:'中文名称',
        color:'颜色',
        length:'长度',
        supplier:'供应商',
        wareHouseCode:'仓库编号',
        wareHouseAddress:'仓库地址',
        lengthUnit:'长度单位',
        numberId:'数量',
        unit:'基本单位',
        basZip:'基础拉链',
        queryWarn:'ItemCode、ItemName、中文名称、基础拉链需至少一个必填！',
        warnText:'温馨提示：ItemCode、ItemName、中文名称、基础拉链需至少一个必填！',
        orderNum:'下单数量',
        orderBtn:'批量下单（已选{0}项）',
        orderConfirm:'批量下单确认',
        Address:'送货地址',
        ContactPer:'联系人',
        PhoneNumber:'联系电话',
        InvoType:'开票类型',
        OrderTableTitle:'已下单项（{0}项）',
        Confirm:'确认下单',
    },
}